#import "./CanvasBlockBaseFields.graphql"

fragment TextBlockFields on TextBlock {
  ...CanvasBlockBaseFields
  body
}
